import './Dashboard.scss';
import 'data/storage';
import buildQuery from 'odata-query';
import moment from 'moment';
import { v4 as uuid } from 'uuid';
import * as DefaultAvatar from 'assets/img/icons/avatar-default.png';
import { DashboardFeatures } from 'modules/application/detail/attendance/dashboard/DashboardFeatures';
import { AttendanceConstants } from '../AttendanceConstants';
import { MILLISSECONDS_IN_SECOND, getFormattedDateTimeOnTimer } from 'data/date';
import { DashboardAttendanceConstants } from './DashboardAttendanceConstants';
import { TicketStatusEnum } from './DashboardService';
import { TransferTicketModalController } from './transferTicketModal/TransferTicketModalController';
import TransferTicketModalView from './transferTicketModal/TransferTicketModalView.html';
import { CloseTicketModalController } from './closeTicketModal/CloseTicketModalController';
import CloseTicketModalView from './closeTicketModal/CloseTicketModalView.html';
import { RealTimeSidebarController } from 'modules/application/detail/attendance/dashboard/realTimeSidebar/RealTimeSidebarController';
import RealTimeSidebarView from './realTimeSidebar/RealTimeSidebarView.html';
import { TAG_KEY } from 'modules/application/detail/attendance/generalsettings/GeneralSettingsController';
import { GeneralSettingsConstants } from 'modules/application/detail/attendance/generalsettings/GeneralSettingsConstants';
import { sortTags, sortByStringValue } from 'data/function';
import { getDecodedNodeName } from 'data/lime';
import { DeskControllerBase } from '../DeskControllerBase';
import { formatEmptyTimeV2, formatTimeString } from 'modules/application/detail/attendance/AttendanceUtils';
import { DashboardTeam } from 'modules/application/detail/attendance/models/DashboardTeam';
import { AttendanceFeatures } from '../AttendanceFeatures';
import { debounce } from 'data/function';
import { AttendantStatus } from './attendantStatus';
import { ThemeConstants } from 'modules/shared/ThemeConstants';
import { UserFeatures } from '../../users/UserFeatures';
import { DeskConstants } from '../desk/DeskConstants';
export class DashboardAttendanceController extends DeskControllerBase {
    static $inject = ['application', 'PermissionsService', 'DeskConfigurationService', 'LoadingService', '$rootScope', '$location', '$timeout', '$stateParams', 'MESSAGINGHUBDOMAIN', 'ChatService', 'DashboardService', 'DashboardRealTimeMonitoringService', 'BucketService', 'SegmentService', 'AccountService2', 'UsersService', 'ConfigurationsService', 'TeamService', 'TagsQueueService', 'ModalService', 'ngToast', '$interval', '$translate', 'SidebarContentService', 'FullScreenService', '$document', '$state', '$scope', '$window', 'BlipToastService', 'AlertService', 'TenantService', 'PriorityLoadValues', 'MONITORING_SCREEN_REFRESH_PAGE_TIMEOUT'];
    constructor(application, PermissionsService, DeskConfigurationService, LoadingService, $rootScope, $location, $timeout, $stateParams, MESSAGINGHUBDOMAIN, ChatService, DashboardService, DashboardRealTimeMonitoringService, BucketService, SegmentService, AccountService2, UsersService, ConfigurationsService, TeamService, TagsQueueService, ModalService, ngToast, $interval, $translate, SidebarContentService, FullScreenService, $document, $state, $scope, $window, BlipToastService, AlertService, TenantService, PriorityLoadValues, MONITORING_SCREEN_REFRESH_PAGE_TIMEOUT) {
        'ngInject';
        super(application, LoadingService, DeskConfigurationService, $scope);
        this.application = application;
        this.PermissionsService = PermissionsService;
        this.DeskConfigurationService = DeskConfigurationService;
        this.LoadingService = LoadingService;
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
        this.ChatService = ChatService;
        this.DashboardService = DashboardService;
        this.DashboardRealTimeMonitoringService = DashboardRealTimeMonitoringService;
        this.BucketService = BucketService;
        this.SegmentService = SegmentService;
        this.AccountService2 = AccountService2;
        this.UsersService = UsersService;
        this.ConfigurationsService = ConfigurationsService;
        this.TeamService = TeamService;
        this.TagsQueueService = TagsQueueService;
        this.ModalService = ModalService;
        this.ngToast = ngToast;
        this.$interval = $interval;
        this.$translate = $translate;
        this.SidebarContentService = SidebarContentService;
        this.FullScreenService = FullScreenService;
        this.$document = $document;
        this.$state = $state;
        this.$scope = $scope;
        this.$window = $window;
        this.BlipToastService = BlipToastService;
        this.AlertService = AlertService;
        this.TenantService = TenantService;
        this.PriorityLoadValues = PriorityLoadValues;
        this.MONITORING_SCREEN_REFRESH_PAGE_TIMEOUT = MONITORING_SCREEN_REFRESH_PAGE_TIMEOUT;
        this.teamsToChoose = [];
        this.teamsChosen = [];
        this.attendantsToChoose = [];
        this.customerOptions = [];
        this.attendantsChosen = [];
        this.customersToFilter = [];
        this.page = 1;
        this.totalNumberPages = 0;
        this.totalNumberItems = 0;
        this.listItemsPerPage = [10, 25, 50, 100, 250, 500];
        this.theme = ThemeConstants.LIGHT;
        this.showWidgetHelpCenter = true;
        this.dashboardTabs = {
            openTickets: 0,
            waitingTickets: 1,
            attendants: 2,
            teams: 3,
            tags: 4,
        };
        this.currentTabIndex = this.dashboardTabs.openTickets;
        this.getTeamsOptions = async (query) => {
            return this.teamsToChoose.filter((option) => option.label.toLowerCase().includes(query.toLowerCase()));
        };
        this.getAttendantsOptions = async (query) => {
            return this.attendantsToChoose.filter((option) => option.label.toLowerCase().includes(query.toLowerCase()));
        };
        this.startPaginationAndFilter = () => {
            this.page = 1;
            this.totalNumberPages = 0;
            this.totalNumberItems = 0;
        };
        this.getTeamsChosenName = () => {
            const key = 'value';
            if (this.currentTabIndex === 2) {
                const directTransferTeam = this.teamsChosen.find(team => team[key] === AttendanceConstants.DIRECT_TRANSFER_TEAM);
                if (directTransferTeam) {
                    return this.teams.filter(team => team[key] !== directTransferTeam.text).map(team => team[key]);
                }
            }
            return this.teamsChosen.map((t) => t[key]);
        };
        this.onChangePage = async (page) => {
            this.page = page;
            await this.refreshOnlyTab(this.isUseCacheEnable);
        };
        this.onChangeItemPerPage = async (itemsPerPage) => {
            this.itemsPerPage = itemsPerPage;
            this.$window.localStorage.setItem(DashboardAttendanceConstants.ITEMS_PER_PAGE, String(itemsPerPage));
            this.totalNumberPages = 0;
            this.totalNumberItems = 0;
            this.page = 1;
            await this.refreshOnlyTab(this.isUseCacheEnable);
        };
        this.onChangeSearch = async ({ detail }) => {
            const { value, name } = detail;
            if (value === this.searchTerm.value) {
                return;
            }
            this.searchTerm.value = value;
            this.searchTerm.name = name;
            this.SegmentService.createApplicationTrack({
                trackEvent: DashboardAttendanceConstants.MONITORING_TICKET_SEARCHED,
                payload: {}, application: this.application,
            });
            this.startPaginationAndFilter();
            await this.refreshOnlyTab(this.isUseCacheEnable);
        };
        this.updateFilterAttendant = (items) => {
            this.attendant = items.map(({ label }) => label);
            this.attendantsChosen = items;
        };
        this.updateFilterTeams = (items) => {
            this.team = items.map(({ label }) => label);
            this.teamsChosen = items;
        };
        this.handleFilterTeams = async (items) => {
            this.teams = items;
            this.teamsChosen = this.teamsToChoose.filter((item) => items.includes(item.label));
            await this.filterTeams();
        };
        this.handleFilterTeam = async (value) => {
            this.team = this.teamsToChoose.filter((option) => option.value.toLowerCase() === (value.toLowerCase()));
            this.teamsChosen = [...this.teamsChosen, ...this.team];
            await this.filterTeams();
        };
        this.filterTeams = async () => {
            this.setUrlQueryParameters('team', this.teamsChosen, 'label');
            this.startPaginationAndFilter();
            await this.refreshAll();
            this.SegmentService.createApplicationTrack({
                trackEvent: DashboardAttendanceConstants.MONITORING_QUEUE_FILTERED,
                payload: {}, application: this.application,
            });
        };
        this.handleFilterAttendantStatus = async (items) => {
            this.attendatsStatusChosen = this.attendantsStatusToChoose.filter((item) => items.includes(item.label));
            this.startPaginationAndFilter();
            this.SegmentService.createApplicationTrack({
                trackEvent: DashboardAttendanceConstants.MONITORING_ATTENDANT_STATUS_FILTERED,
                payload: {}, application: this.application,
            });
            await this.refreshOnlyTab(this.isUseCacheEnable);
        };
        this.refreshOnlyTab = async (useCache = false) => {
            if (this.isRefreshing) {
                return;
            }
            this.isRefreshing = true;
            this.refreshCache = !useCache;
            this.$scope.stop();
            try {
                await this.getTablesPromises();
            }
            finally {
                this.isRefreshing = false;
                this.startRefreshPromisse();
            }
        };
        this.handleFilterAttendants = async (items) => {
            const filteredAttendants = this.attendantsToChoose.filter((item) => items.includes(item.label.trim()));
            await this.filterAttendants(filteredAttendants);
        };
        this.handleFilterAttendant = async (items) => {
            this.attendant = this.attendantsToChoose.filter((option) => option.value.toLowerCase() === (items.toLowerCase()));
            this.attendantsChosen = [...this.attendantsChosen, ...this.attendant];
            await this.filterAttendants(this.attendantsChosen);
        };
        this.onAttendantRemoved = async (event) => {
            const removedAttendant = event.detail.id;
            const filteredAttendants = this.attendantsChosen.filter((item) => item.label.trim() !== removedAttendant);
            await this.filterAttendants(filteredAttendants);
        };
        this.filterAttendants = async (filteredAttendants) => {
            this.setUrlQueryParameters('attendant', filteredAttendants, 'label');
            this.updateFilterAttendant(filteredAttendants);
            this.startPaginationAndFilter();
            this.SegmentService.createApplicationTrack({
                trackEvent: DashboardAttendanceConstants.MONITORING_ATTENDANT_FILTERED,
                application: this.application,
            });
            await this.refreshOnlyTab(this.isUseCacheEnable);
        };
        this.onCustomerSelect = async (value) => {
            const hasAlreadyFiltered = this.customersToFilter.some(c => c.value === value);
            if (hasAlreadyFiltered) {
                return;
            }
            const selectedOption = this.customerOptions.find(c => c.value === value);
            const customersToFilter = [...this.customersToFilter, selectedOption];
            await this.filterCustomers(customersToFilter);
        };
        this.onCustomerRemoved = async (event) => {
            const removedCustomer = event.detail.id;
            const customersToFilter = this.customersToFilter.filter(c => c.value !== removedCustomer);
            await this.filterCustomers(customersToFilter);
        };
        this.onTeamRemoved = async (event) => {
            const removedTeam = event.detail.id;
            this.team = this.teamsChosen.filter(c => c.value !== removedTeam);
            this.teamsChosen = this.team;
            await this.filterTeams();
        };
        this.filterCustomers = async (filteredCustomers) => {
            this.setUrlQueryParameters('customer', filteredCustomers, 'value');
            this.customersToFilter = filteredCustomers;
            this.startPaginationAndFilter();
            this.SegmentService.createApplicationTrack({
                trackEvent: DashboardAttendanceConstants.MONITORING_CONTACT_FILTERED,
                application: this.application,
            });
            await this.refreshOnlyTab(this.isUseCacheEnable);
        };
        this.getCustomerOptions = async (value) => {
            const customerOptions = await this.customCustomersSearch(value);
            this.customerOptions = customerOptions;
            return customerOptions;
        };
        this.customerResponseToOptions = (customerResponse) => {
            const customerInfos = [
                customerResponse.name,
                customerResponse.email ?? customerResponse.identity,
                customerResponse.phoneNumber,
            ];
            const customerLabel = customerInfos.filter(c => c).join(' - ').trim();
            return {
                label: customerLabel,
                value: customerResponse.identity.trim(),
            };
        };
        this.getTranslation = (label) => {
            const baseLabel = 'modules.application.detail.attendance.analytics.page';
            return `${baseLabel}.v1.${label}`;
        };
        this.setTotalPagination = (total) => {
            this.totalNumberPages = total ? Math.ceil(total / this.itemsPerPage) : 1;
            this.totalNumberItems = total ? total : 0;
        };
        this.attendantDisconnect = async (agentIdentity) => {
            try {
                this.SegmentService.createApplicationTrack({
                    trackEvent: DashboardAttendanceConstants.MONITORING_DISCONNECT_AGENT,
                });
                await this.DashboardService.attendantDisconnect(agentIdentity);
                const msg = await this.$translate('modules.application.detail.attendance.analytics.page.list.agents.disconnectAgentAlert.success');
                this.BlipToastService.show('success', {
                    msg,
                });
            }
            catch (error) {
                if (error.code == 21) {
                    const [attendant] = this.attendants.filter(a => a.identity === agentIdentity);
                    const msg = await this.$translate('modules.application.detail.attendance.analytics.page.list.agents.disconnectAgentAlert.warning', { attendant: this.getAttendantName(attendant),
                    });
                    this.BlipToastService.show('warning', {
                        msg,
                    });
                }
                else {
                    const msg = await this.$translate('modules.application.detail.attendance.analytics.page.list.agents.disconnectAgentAlert.error');
                    this.BlipToastService.show('danger', {
                        msg,
                    });
                }
                console.error('Failed to send disconnection alert', error);
            }
        };
        this.showConfirmDisconnectAlert = async (agentIdentity) => {
            if (!this.canEditDesk) {
                return;
            }
            const modalTitle = await this.$translate('modules.application.detail.attendance.analytics.page.list.agents.disconnectAgentAlert.title');
            const modalBody = await this.$translate('modules.application.detail.attendance.analytics.page.list.agents.disconnectAgentAlert.body');
            const confirm = await this.$translate('modules.application.detail.attendance.analytics.page.list.agents.disconnectAgentAlert.confirm');
            const cancel = await this.$translate('modules.application.detail.attendance.analytics.page.list.agents.disconnectAgentAlert.cancel');
            await this.AlertService.show({
                title: modalTitle,
                body: modalBody,
                variant: 'warning',
                icon: 'warning',
                buttons: {
                    cancel: cancel,
                    confirm: confirm,
                },
                callback: {
                    cancelButtonAction: () => { },
                    confirmButtonAction: async () => { await this.attendantDisconnect(agentIdentity); },
                },
            });
        };
        this.startRefreshPromisse();
    }
    async $onInit() {
        this.debouncedSearch = debounce(this.onChangeSearch, 500);
        this.itemsPerPageDefault = 50;
        this.defaultAvatar = DefaultAvatar;
        this.searchTerm = { name: 'ticketSequentialId', value: '' };
        this.attendants = [];
        this.teams = [];
        this.tags = [];
        this.openTickets = [];
        this.waitingTicketsList = [];
        this.attendantsStatusToChoose =
            [
                { value: AttendantStatus.ONLINE, label: await this.$translate('attendantStatus.online') },
                { value: AttendantStatus.PAUSE, label: await this.$translate('attendantStatus.pause') },
                { value: AttendantStatus.INVISIBLE, label: await this.$translate('attendantStatus.invisible') },
                { value: AttendantStatus.OFFLINE, label: await this.$translate('attendantStatus.offline') },
            ];
        this.closeTicketTags = [];
        this.attendatsStatusChosen = [];
        this.isRefreshing = false;
        this.refreshCache = true;
        this.lastManualRefreshDateTime = 0;
        this.canEditDesk = await this.PermissionsService.hasPermissions(DeskConstants.WRITE, DeskConstants.DESK);
    }
    async setIfPriorityIsEnabled() {
        this.deskConfiguration = await this.getOwnerConfiguration(GeneralSettingsConstants.ITEMS_PER_PAGE_DESK_MONITORING);
        this.isPriorityFeaturetoggleEnabled = await AttendanceFeatures.isPriorityAttendanceQueueEnabled();
        const isOrleansEnabled = this.deskConfiguration[AttendanceConstants.DISTRIBUTION_TYPE] === AttendanceConstants.ORLEANS_DISTRIBUTION;
        const isRedisEnabled = this.deskConfiguration[AttendanceConstants.DISTRIBUTION_TYPE] === AttendanceConstants.REDIS_DISTRIBUTION;
        this.isPriorityEnabled = this.isPriorityFeaturetoggleEnabled && (isOrleansEnabled || isRedisEnabled);
    }
    async initialized() {
        const { ItemsPerPageDeskMonitoring, CanTransferWithoutAgents } = this.deskConfiguration !== undefined
            ? this.deskConfiguration
            : await this.getOwnerConfiguration(GeneralSettingsConstants.ITEMS_PER_PAGE_DESK_MONITORING);
        this.itemsPerPage = Number(this.$window.localStorage.getItem(DashboardAttendanceConstants.ITEMS_PER_PAGE));
        if (this.itemsPerPage === 0) {
            this.itemsPerPage = ItemsPerPageDeskMonitoring > 0 ? ItemsPerPageDeskMonitoring : this.itemsPerPageDefault;
        }
        if (!this.listItemsPerPage.includes(ItemsPerPageDeskMonitoring) && ItemsPerPageDeskMonitoring > 0) {
            this.listItemsPerPage = [...this.listItemsPerPage, ItemsPerPageDeskMonitoring]
                .sort((item, items) => item - items);
        }
        this.$scope.stop = () => {
            this.$interval.cancel(this.refreshPromise);
        };
        this.ticketsPerHourChart = this.getChartObject();
        this.addFullScreenEventListener();
        this.DashboardRealTimeMonitoringService.getMonitoringScreenRefreshAlert().subscribe(() => {
            this.refreshAll(false);
        });
        this.priorityLabels = await this.PriorityLoadValues.loadPriorityLabel();
        this.$scope.$on('$destroy', () => {
            this.removeFullScreenEventListener();
            if (!this.ChatService.built) {
                this.ChatService.build();
            }
            this.$scope.stop();
        });
        this.isBillablePlanContract = await this.TenantService.checkIfBillableContract();
        this.canTransferWithoutAgents = CanTransferWithoutAgents?.toLowerCase() === 'true';
        try {
            const [teams, attendants, customers] = await Promise.all([
                this.getTeamsToChoose(),
                this.TeamService.getAllAttendants('', DashboardAttendanceConstants.DEFAULT_NUMBER_OF_AGENTS),
                this.getCustomersFromQuery(),
            ]);
            this.teamsToChoose = teams;
            this.attendantsToChoose = attendants.map((item) => ({ value: item.identity, label: item.fullName }));
            this.customersToFilter = customers;
        }
        catch (error) {
            console.error(error);
        }
        await this.loadQuery('attendant', 'attendantsToChoose', 'label', this.updateFilterAttendant);
        await this.loadQuery('team', 'teamsToChoose', 'label', this.updateFilterTeams);
        this.refreshAll(false);
        const text = await this.$translate('helper.doc.text');
        const link = await this.$translate('helper.doc.link');
        this.helperLink = { text, link };
        this.SegmentService.createApplicationTrack({
            trackEvent: DashboardAttendanceConstants.MONITORING_OPENED,
            application: this.application
        });
    }
    async getTeamsToChoose() {
        const teamsResponse = await this.TeamService.getTeams(this.application);
        const teams = teamsResponse.items.map((item) => ({ value: item.name, label: item.name }));
        teams.push({
            value: AttendanceConstants.DIRECT_TRANSFER_TEAM,
            label: await this.$translate('directTransfer'),
        });
        teams.sort(sortByStringValue);
        return teams;
    }
    async getCustomersFromQuery() {
        if (!this.$stateParams.customer) {
            return [];
        }
        let customerIdentities = [];
        if (Array.isArray(this.$stateParams.customer)) {
            customerIdentities = this.$stateParams.customer;
        }
        else {
            customerIdentities.push(this.$stateParams.customer);
        }
        const query = customerIdentities.map(identity => `identity eq '${identity}'`).join(' or ');
        const filter = `&$filter=${encodeURIComponent(query)}`;
        const customersResponse = await this.UsersService.getUsers(filter, 0, 100);
        return customersResponse.items.map(this.customerResponseToOptions);
    }
    async checkFeatures() {
        await super.checkFeatures();
        const [isTagsQueueFeaturetoggleEnabled, itemsPerPage, isUsingStartsWithOnContactsSearch, isWidgetBlipChatHelpCenterMonitoringEnabled, isAutocompleFiltersEnabled, isStatusCallEnabled, isDisconnectAttendant, isUseCacheEnable, isConfigurationsApplicationsDomainUsageGetEnabled, isMonitoringMfeEnabled] = await Promise.all([
            AttendanceFeatures.isTagsQueueEnabled(),
            DashboardFeatures.isMonitoringItemPerPage(),
            UserFeatures.isUsingStartsWithOnContactsSearch(),
            DashboardFeatures.isWidgetBlipChatHelpCenterMonitoringEnabled(),
            DashboardFeatures.isAutocompleFiltersEnabled(),
            DashboardFeatures.isStatusCallEnabled(),
            DashboardFeatures.isDisconnectAttendant(),
            DashboardFeatures.isUseCacheEnable(),
            AttendanceFeatures.isUseConfigurationsDomainOnAttendanceOperationsGetEnabled(),
            AttendanceFeatures.isMonitoringMfeEnabled(),
        ]);
        this.isTagsQueueFeaturetoggleEnabled = isTagsQueueFeaturetoggleEnabled;
        this.itemsPerPage = itemsPerPage;
        this.isUsingStartsWithOnContactsSearch = isUsingStartsWithOnContactsSearch;
        this.isWidgetBlipChatHelpCenterMonitoringEnabled = isWidgetBlipChatHelpCenterMonitoringEnabled;
        this.isAutocompleFiltersEnabled = isAutocompleFiltersEnabled;
        this.isStatusCallEnabled = isStatusCallEnabled;
        this.isDisconnectAttendant = isDisconnectAttendant;
        this.isUseCacheEnable = isUseCacheEnable;
        this.isConfigurationsApplicationsDomainUsageGetEnabled = isConfigurationsApplicationsDomainUsageGetEnabled;
        this.refreshCache = !this.isUseCacheEnable;
        if (isMonitoringMfeEnabled) {
            this.$state.go('auth.application.detail.attendance.desk.monitoring');
            return;
        }
        if (itemsPerPage !== 0) {
            this.itemsPerPageDefault = itemsPerPage;
        }
        await this.setIfPriorityIsEnabled();
        await this.initialized();
    }
    /**
     * Requests FullScreenService to add 'fullscreenchange' custom event listener
     */
    addFullScreenEventListener() {
        this.fullscreenEventFunction = this.refreshAll.bind(this, true);
        this.applyThemeFullScreenEventFunction = this.applyTheme.bind(this);
        this.FullScreenService.addFullScreenCustomListener(this.fullscreenEventFunction);
        this.FullScreenService.addFullScreenCustomListener(this.applyThemeFullScreenEventFunction);
    }
    /**
     * Requests FullScreenService to remove 'fullscreenchange' custom event listener
     */
    removeFullScreenEventListener() {
        this.FullScreenService.removeFullScreenCustomListener(this.fullscreenEventFunction);
        this.FullScreenService.removeFullScreenCustomListener(this.applyThemeFullScreenEventFunction);
    }
    /**
     * Start interval to refresh data
     */
    startRefreshPromisse() {
        const refreshPageTimeout = this.MONITORING_SCREEN_REFRESH_PAGE_TIMEOUT;
        this.refreshPromise = this.$interval(this.refreshAll.bind(this), refreshPageTimeout);
    }
    /**
     * Refresh button action
     */
    refreshAllAndTrack(shouldUpdateChart = false) {
        this.SegmentService.createApplicationTrack({ trackEvent: DashboardAttendanceConstants.MONITORING_REFRESH, payload: {}, application: this.application });
        this.refreshCache = true;
        this.refreshAll(shouldUpdateChart);
    }
    /**
     * Refresh all dashboard data - cards, tables and chart
     *
     * @param shouldUpdateChart - param to allow chart update
     * @returns promise for refreshing all dashboard data
     */
    async refreshAll(shouldUpdateChart = false) {
        const statisticsPromises = this.getStatisticsPromises();
        const tablesPromises = this.getTablesPromises();
        if (shouldUpdateChart) {
            this.refreshChartAndInterval();
        }
        try {
            this.isRefreshing = true;
            this.dateTimeNow = new Date();
            await Promise.all([
                ...statisticsPromises,
                tablesPromises,
            ]);
            this.updateRealTimeActiveTicket();
        }
        catch (e) {
            const errorMsg = this.$translate.instant('errors.refreshData');
            this.ngToast.danger(errorMsg);
        }
        finally {
            this.isRefreshing = false;
            this.refreshCache = !this.isUseCacheEnable;
            this.lastManualRefreshDateTime = Date.now();
        }
    }
    /**
     * Refresh tickets per hour chart and restart interval
     *
     * @returns promise for refreshing chart data and update interval
     */
    async refreshChartAndInterval() {
        if (!this.FullScreenService.isOnFullScreen) {
            return;
        }
        this.isLoadingTicketsPerHourChart = true;
        try {
            await this.getTicketsPerHourPromise();
        }
        catch (e) {
            const errorMsg = this.$translate.instant('errors.refreshChart');
            this.ngToast.danger(errorMsg);
        }
        finally {
            this.resetChartInterval();
            this.$timeout(() => this.isLoadingTicketsPerHourChart = false);
        }
    }
    /**
     * Reset interval that refreshes tickets per hour chart
     */
    resetChartInterval() {
        clearInterval(this.refreshChartInterval);
        const refreshTimeout = 10 * 60 * 1000;
        this.refreshChartInterval = setInterval(this.refreshChartAndInterval, refreshTimeout);
    }
    /**
     * Update real time's active thread ticket
     */
    updateRealTimeActiveTicket() {
        if (this.FullScreenService.isOnFullScreen) {
            return;
        }
        const updatedActiveTicket = this.openTickets.find((t) => {
            return (this.activeThreadTicket &&
                t.customerIdentity ===
                    this.activeThreadTicket.customerIdentity);
        }) ||
            this.waitingTicketsList.find((t) => {
                return (this.activeThreadTicket &&
                    (this.activeThreadTicket.status === 'ClosedAttendant' ||
                        this.activeThreadTicket.status === 'ClosedClient') &&
                    t.customerIdentity === this.activeThreadTicket.customerIdentity);
            });
        if (updatedActiveTicket) {
            this.$rootScope.$broadcast('UPDATE_TICKET', {
                ticket: updatedActiveTicket,
            });
        }
    }
    /**
     * Get all promises related to the dashboard statistics cards
     *
     * @returns array of all dashboard card-related promises
     */
    getStatisticsPromises() {
        const ticketStatisticsPromise = this.getTicketStatisticsPromise();
        const timeStatisticsPromise = this.getTimeStatisticsPromise();
        const attendantsStatusPromise = this.getAttendantsStatusPromise();
        return [
            ticketStatisticsPromise,
            timeStatisticsPromise,
            attendantsStatusPromise,
        ];
    }
    /**
     * Get all promises related to the dashboard tables
     *
     * @returns array of all dashboard table-related promises
     */
    getTablesPromises() {
        if (this.FullScreenService.isOnFullScreen) {
            return this.getOpenTicketsPromise();
        }
        switch (this.currentTabIndex) {
            case this.dashboardTabs.waitingTickets:
                return this.getWaitingTicketsPromise();
            case this.dashboardTabs.attendants:
                return this.getAttendantsTablePromise(this.getAttendantsPromise());
            case this.dashboardTabs.teams:
                return this.getTeamsPromise();
            case this.dashboardTabs.tags:
                return this.getTagsPromise();
            default:
                return this.getOpenTicketsPromise();
        }
    }
    /**
     * Get promise for loading ticket-related statistics
     *
     * @returns promise that fetches ticket-related statistics
     */
    getTicketStatisticsPromise() {
        return this.DashboardService.getTicketsSummary(this.buildReportRequest()).then((data) => {
            data = data || {};
            this.waitingTickets = data.waiting || 0;
            this.lostTickets = data.missed || 0;
            this.abandonedTickets = data.closedClient || 0;
            this.closedTickets = data.closed || 0;
            this.inAttendanceTickets = data.inAttendance || 0;
            const closedAttendantTickets = data.closedAttendant || 0;
            const transferredTickets = data.transferred || 0;
            this.attendedTickets = closedAttendantTickets + transferredTickets;
        });
    }
    /**
     * Get promise for loading time-related statistics
     *
     * @returns promise that fetches time-related statistics
     */
    getTimeStatisticsPromise() {
        return this.DashboardService.getTicketsMetricsSummary(this.buildReportRequest()).then((data) => {
            const zeroToDash = true;
            data = data || {};
            this.maxQueueTime = this.formatTime({ value: data.maxQueueTime, zeroToDash });
            this.maxCollapsedQueueTime = this.formatTime({ value: data.maxQueueTime, zeroToDash, collapsed: true });
            this.maxWithoutFirstResponseTime = this.formatTime({ value: data.maxWithoutFirstResponseTime, zeroToDash });
            this.maxCollapsedWithoutFirstResponseTime = this.formatTime({ value: data.maxWithoutFirstResponseTime, zeroToDash, collapsed: true });
            this.ticketPerAttendant = Math.round(parseFloat(data.ticketsPerAttendant) * 100) / 100;
            this.avgWaitTime = this.formatTime({ value: data.avgWaitTime, zeroToDash });
            this.avgCollapsedWaitTime = this.formatTime({ value: data.avgWaitTime, zeroToDash, collapsed: true });
            this.avgResponseTime = this.formatTime({ value: data.avgResponseTime, zeroToDash });
            this.avgCollapsedResponseTime = this.formatTime({ value: data.avgResponseTime, zeroToDash, collapsed: true });
            this.avgFirstResponseTime = this.formatTime({ value: data.avgFirstResponseTime, zeroToDash });
            this.avgCollapsedFirstResponseTime = this.formatTime({ value: data.avgFirstResponseTime, zeroToDash, collapsed: true });
            this.avgAttendanceTime = this.formatTime({ value: data.avgAttendanceTime, zeroToDash });
            this.avgCollapsedAttendanceTime = this.formatTime({ value: data.avgAttendanceTime, zeroToDash, collapsed: true });
        });
    }
    /**
     * Add formatted id to help search
     *
     * @returns object ticket with formatted id.
     */
    addFormatedTicketSequentialId(ticket) {
        return { ...ticket, formatedSequentialId: `#${ticket.sequentialId}` };
    }
    /**
     * Get promise for loading open tickets data
     *
     * @returns promise that fetches open tickets
     */
    getOpenTicketsPromise() {
        return this.DashboardService.getOpenTickets(this.buildReportRequest())
            .then((data) => {
            this.baseOpenTicketsList =
                data && data.items
                    ? this.formatOpenTicketsTimeAndStatus(data.items).sort((a, b) => {
                        if (!a.attendanceTime && b.attendanceTime) {
                            return -1;
                        }
                        if (a.attendanceTime && !b.attendanceTime) {
                            return 1;
                        }
                        return a.sequentialId - b.sequentialId;
                    }).map(this.addFormatedTicketSequentialId)
                    : [];
            // Get open tickets with first response
            const { total } = data;
            this.insertDirectTransferTranslationOnTicketList(this.baseOpenTicketsList);
            this.openTickets = this.baseOpenTicketsList;
            this.setTotalPagination(total);
        });
    }
    /**
     * Get promise for loading waiting tickets data
     *
     * @returns promise that fetches waiting tickets
     */
    getWaitingTicketsPromise() {
        return this.DashboardService.getWaitingTickets(this.buildReportRequest())
            .then((data) => {
            this.baseWaitingTicketsList =
                data && data.items
                    ? this.formatWaitingTicketsTimeAndStatus(data.items).sort((a, b) => {
                        if (a.priority === b.priority) {
                            return a.sequentialId - b.sequentialId;
                        }
                        return a.priority < b.priority ? 1 : -1;
                    })
                    : [];
            const { total } = data;
            this.insertDirectTransferTranslationOnTicketList(this.baseWaitingTicketsList);
            this.waitingTicketsList = this.baseWaitingTicketsList;
            this.setTotalPagination(total);
        });
    }
    /**
     * Get base promise for loading attendants, used to display
     * both count by status and attendants details table
     *
     * @returns promise that fetches an array with all attendants
     */
    getAttendantsPromise() {
        return this.DashboardService.getAttendants(this.buildReportRequest())
            .then(data => {
            const { total } = data;
            this.setTotalPagination(total);
            return (data && data.items) || [];
        });
    }
    /**
     * Get promise for attendants count by status
     *
     * @returns promise that updates attendants count by status when finished
     */
    getAttendantsStatusPromise() {
        return this.DashboardService.getAttendantMetricsSummary(this.buildReportRequest()).then((items) => {
            this.onlineAttendants = items ? items.online : 0;
            this.pauseAttendants = items ? items.pause : 0;
            this.invisibleAttendants = items ? items.invisible : 0;
        });
    }
    /**
     * Get promise for attendants details table
     *
     * @returns promise that updates attendants details table
     */
    getAttendantsTablePromise(attendantsPromise) {
        return attendantsPromise
            .then(items => {
            const agents = this.formatAttendantsTimeString(items);
            this.baseAttendantsList = this.sortAttendants(agents);
            this.attendants = this.baseAttendantsList;
        })
            .then(() => {
            if (this.isStatusCallEnabled) {
                this.DashboardService.getActiveCallsSession()
                    .then((data) => {
                    const activeSessions = (data && data.items) || [];
                    activeSessions.forEach((s) => {
                        const agent = this.attendants.find(t => t.identity === s.agentIdentity);
                        if (agent) {
                            agent.callSessionType = s.type;
                        }
                    });
                })
                    .catch(err => {
                    if (err.code !== 67) { // Resource not found
                        console.error('Failed to get active sessions call => ' + err);
                    }
                });
            }
        });
    }
    /**
     * Get teams promise
     *
     * @returns promise that fetches teams
     */
    getTeamsPromise() {
        return this.DashboardService.getTeams(this.buildReportRequest()).then((data) => {
            const { total } = data;
            this.baseTeamsList = DashboardTeam.fromList(data.items);
            this.insertDirectTransferTranslationOnTeam(this.baseTeamsList);
            const teams = this.baseTeamsList;
            const undefinedToDash = true;
            teams.forEach((t) => {
                t.averageWaitTime = this.formatTime({ value: t.averageWaitTime, undefinedToDash });
                t.averageCollapsedWaitTime = this.formatTime({ value: t.averageWaitTime, undefinedToDash, collapsed: true });
                t.averageResponseTime = this.formatTime({ value: t.averageResponseTime, undefinedToDash });
                t.averageCollapsedResponseTime = this.formatTime({ value: t.averageResponseTime, undefinedToDash, collapsed: true });
                t.averageAttendanceTime = this.formatTime({ value: t.averageAttendanceTime, undefinedToDash });
                t.averageCollapsedAttendanceTime = this.formatTime({ value: t.averageAttendanceTime, undefinedToDash, collapsed: true });
            });
            this.teams = teams;
            this.setTotalPagination(total);
        });
    }
    /**
     * Get promise for loading tags report
     *
     * @returns promise that fetches tags data
     */
    getTagsPromise() {
        return this.DashboardService.getTags({
            ...this.buildReportRequest(),
        }).then((tags) => {
            const { total } = tags;
            this.setTotalPagination(total);
            this.baseTagsList = this.formatTagsTimeString(tags.items);
            this.tags = this.baseTagsList;
        });
    }
    /**
     * Get promise for loading tickets per hour chart data
     *
     * @returns promise that fetches tickets per hour data
     */
    async getTicketsPerHourPromise() {
        try {
            const { items } = await this.DashboardService.getTicketsPerHour(this.buildReportRequest());
            const chartData = [];
            const itemsLength = items.length;
            if (items && itemsLength > 0) {
                const hourOfFirstItem = moment(items[0].storageDate);
                chartData.push([hourOfFirstItem.format('HH:00'), 0]);
                // +1 so chart's hours respect the logic of 12:00 representing 11:01 to 12:00.
                const baseHour = hourOfFirstItem.add(1, 'hour');
                items.forEach(item => {
                    item.storageDate = moment(item.storageDate).add(1, 'hour');
                    while (baseHour.isBefore(item.storageDate)) {
                        chartData.push([baseHour.format('HH:00'), 0]);
                        baseHour.add(1, 'hour');
                    }
                    chartData.push([
                        item.storageDate.format('HH:00'),
                        item.ticketByHour,
                    ]);
                    baseHour.add(1, 'hour');
                });
            }
            this.ticketsPerHourChart.data = chartData.length > 0
                ? [['Hour', 'Tickets per hour'], ...chartData]
                : undefined;
        }
        catch (error) {
            this.ticketsPerHourChart.data = undefined;
            throw new Error(error);
        }
    }
    getPriorityUrgencyLabel(priority) {
        const priorityLevels = [4000, 3000, 2000, 1000, 0];
        const selectedPriority = priorityLevels.find(level => priority >= level);
        return this.priorityLabels?.find(label => label.value === selectedPriority.toString())?.label;
    }
    async transferTicket(ticket, $event) {
        $event.stopPropagation();
        let modal;
        const isDirectTransferFeatureToggleEnabled = await AttendanceFeatures.isDirectTransferEnabled();
        try {
            const { items } = await this.TeamService.getTeamsAndAgentsOnline(this.application);
            const attendants = await this.TeamService.getAllAttendants('', AttendanceConstants.DEFAULT_DIRECT_TRANSFER_REQUESTED_NUMBER_OF_AGENTS);
            const isDirectTransferEnabled = this.deskConfiguration[AttendanceConstants.TRANSFER_DIRECTLY_CONFIG] ?? false;
            const isOrleansEnabled = this.deskConfiguration[AttendanceConstants.DISTRIBUTION_TYPE] === AttendanceConstants.ORLEANS_DISTRIBUTION;
            const isRedisEnabled = this.deskConfiguration[AttendanceConstants.DISTRIBUTION_TYPE] === AttendanceConstants.REDIS_DISTRIBUTION;
            modal = await this.ModalService.showModal({
                template: TransferTicketModalView,
                controller: TransferTicketModalController,
                controllerAs: '$ctrl',
                inputs: {
                    ticket: ticket,
                    teams: items,
                    attendants: attendants.filter(a => a.isEnabled === undefined || a.isEnabled === true),
                    canTransferWithoutAgents: this.canTransferWithoutAgents,
                    isAttendantTransferEnabled: isDirectTransferFeatureToggleEnabled && isDirectTransferEnabled && (isOrleansEnabled || isRedisEnabled),
                },
            });
        }
        catch (e) {
            console.error(e);
            const errorMsg = await this.$translate('transferTicket.errorMsg.1', {
                sequentialId: ticket.sequentialId,
            });
            this.ngToast.danger(errorMsg);
        }
        const { recipient, isTeam } = await modal.close;
        if (recipient === undefined) {
            return;
        }
        try {
            await this.SegmentService.createApplicationTrack({
                trackEvent: DashboardAttendanceConstants.MONITORING_TICKET_TRANSFERRED, application: this.application,
                payload: {
                    TransferredTo: isTeam ? 'Team' : 'Agent',
                },
            });
            isTeam ?
                await this.DashboardService.transferTicketToTeam(ticket.id, recipient) :
                await this.DashboardService.transferTicketToAgent(ticket.id, recipient);
            const successMsg = await this.$translate('utils.successMsg.42');
            const refreshText = await this.$translate('utils.forms.refresh');
            this.BlipToastService.show('success', {
                msg: successMsg,
                buttonText: refreshText,
                callback: () => this.refreshOnlyTab(),
            });
        }
        catch (e) {
            let errorMsg;
            if (e.message.endsWith('Ticket is already closed and cannot be updated')) {
                errorMsg = await this.$translate('utils.errorMsg.158', {
                    sequentialId: ticket.sequentialId,
                });
            }
            else {
                errorMsg = await this.$translate('utils.errorMsg.156', {
                    sequentialId: ticket.sequentialId,
                });
            }
            this.BlipToastService.show('danger', {
                msg: errorMsg,
            });
        }
        finally {
            this.refreshCache = true;
            this.refreshAll(true);
        }
    }
    addTeam(team) {
        this.$rootScope.$broadcast('ToggleDropdownItem');
        this.$rootScope.$broadcast('angucomplete-alt:clearInput');
        this.team = undefined;
        if (!team ||
            !this.teamsToChoose.some(t => t.value === team) ||
            this.teamsChosen.some(t => t.name === team)) {
            return;
        }
        const chosenTeam = this.teamsToChoose.find(teamToChoose => teamToChoose.value === team);
        this.updateTeamChoices(chosenTeam);
        this.setUrlQueryParameters('team', this.teamsChosen, 'name');
        this.SegmentService.createApplicationTrack({
            trackEvent: DashboardAttendanceConstants.MONITORING_QUEUE_FILTERED,
            payload: {}, application: this.application,
        });
        this.refreshAll(true);
    }
    removeTeam(_, removedItem) {
        if (!removedItem || !removedItem.text) {
            return;
        }
        const team = removedItem;
        this.teamsChosen = this.teamsChosen.filter((t) => t.text !== team.text);
        this.teamsToChoose = this.teamsToChoose.concat({
            label: team.text,
            value: team.name,
        });
        this.setUrlQueryParameters('team', this.teamsChosen, 'name');
        this.refreshAll(true);
    }
    async closeTicket(ticket, $event) {
        $event.stopPropagation();
        let resource, tags = [], hasTags, isTagsRequired;
        try {
            resource = await this.BucketService.get(TAG_KEY);
            resource = JSON.parse(resource);
            tags = resource.tags || (Array.isArray(resource) ? resource : []);
            tags = resource?.hasTags ? tags : [];
            if (this.isTagsQueueFeaturetoggleEnabled && ticket.team !== await this.$translate('directTransfer')) {
                const tagsQueueList = await this.TagsQueueService.getTagsQueueName(ticket.team);
                tagsQueueList.forEach(({ tag: tagsQueueAttendance }) => {
                    if (tags.some(tag => tag.text.toLowerCase() ===
                        tagsQueueAttendance.toLowerCase())) {
                        return;
                    }
                    tags.push({ text: tagsQueueAttendance });
                });
            }
            tags = tags.sort(sortTags).map(tag => {
                return {
                    value: tag.text,
                    label: tag.text,
                };
            });
        }
        catch (err) {
            console.error(err);
            resource = {};
        }
        finally {
            if (!tags) {
                tags = [];
            }
            hasTags = (resource?.hasTags || tags.length) > 0;
            isTagsRequired =
                resource?.isTagsRequired && resource?.hasTags;
        }
        let modal;
        try {
            modal = await this.ModalService.showModal({
                template: CloseTicketModalView,
                controller: CloseTicketModalController,
                controllerAs: '$ctrl',
                inputs: {
                    ticket: ticket,
                    tags,
                    hasTags,
                    isTagsRequired,
                },
            });
        }
        catch (e) {
            console.error(e);
            return;
        }
        const selectedTags = await modal.close;
        if (selectedTags) {
            try {
                ticket.tags = selectedTags;
                await this.DashboardService.closeTicket(ticket);
                const successMsg = await this.$translate('utils.successMsg.43', {
                    sequentialId: ticket.sequentialId,
                });
                this.ngToast.success(successMsg);
            }
            catch (e) {
                let errorMsg;
                if (e.message.endsWith('Ticket is already closed and cannot be updated')) {
                    errorMsg = await this.$translate('utils.errorMsg.158', {
                        sequentialId: ticket.sequentialId,
                    });
                }
                else {
                    errorMsg = await this.$translate('utils.errorMsg.166', {
                        sequentialId: ticket.sequentialId,
                    });
                }
                this.ngToast.danger(errorMsg);
            }
            finally {
                this.refreshOnlyTab();
            }
        }
    }
    goToUserHistory(ticket) {
        this.$state.go('auth.application.detail.attendance.history.detail', {
            id: this.UsersService.getDecodedUserIdentity(ticket.customerIdentity),
        });
    }
    setActiveTicket(ticket) {
        this.activeThreadTicket = {
            ...ticket,
        };
    }
    isOverflowTime(registerBreak, dateTimeBreak) {
        if (dateTimeBreak && registerBreak > 0) {
            const nowMilliseconds = this.dateTimeNow.getTime();
            const currentBreak = (nowMilliseconds - new Date(dateTimeBreak).getTime()) / MILLISSECONDS_IN_SECOND;
            return currentBreak > registerBreak;
        }
        return false;
    }
    getFormattedTime(dateTime) {
        return getFormattedDateTimeOnTimer(dateTime, this.dateTimeNow);
    }
    async openThreadSidebar(ticket) {
        if (this.activeThreadTicket &&
            this.activeThreadTicket.id === ticket.id) {
            if (!this.ChatService.built) {
                this.ChatService.build();
            }
            await this.closeThreadSidebar();
            return;
        }
        const threadID = uuid();
        this.setActiveTicket({
            ...ticket,
            threadID,
        });
        if (this.ChatService.built) {
            this.ChatService.destroy();
        }
        let sidenav;
        try {
            sidenav = await this.SidebarContentService.showSidebar({
                controller: RealTimeSidebarController,
                controllerAs: '$ctrl',
                template: RealTimeSidebarView,
                appendToElement: this.$document[0].getElementById('right-sidebar'),
                inputs: {
                    application: this.application,
                    from: `${this.application.shortName}@${this.MESSAGINGHUBDOMAIN}`,
                    to: ticket.customerIdentity,
                    ticket: this.activeThreadTicket,
                    onUpdateTicket: this.setActiveTicket.bind(this),
                    onTransferTicket: this.transferTicket.bind(this),
                    onCloseTicket: this.closeTicket.bind(this),
                    canTransferWithoutAgents: this.canTransferWithoutAgents,
                },
            });
            this.showWidgetHelpCenter = false;
            const userAccount = await this.AccountService2.me();
            await this.SegmentService.createApplicationTrack({ trackEvent: 'show-ticket-thread', payload: {
                    botName: this.application.name,
                    user: userAccount.email,
                }, application: this.application });
        }
        catch (e) {
            console.error(e);
        }
        if (this.ChatService.built) {
            this.ChatService.destroy();
        }
        try {
            await sidenav.closeDeferred.promise;
        }
        catch (e) {
            console.error(e);
        }
        finally {
            if (this.activeThreadTicket.threadID === threadID) {
                this.activeThreadTicket = undefined;
                if (!this.ChatService.built) {
                    this.ChatService.build();
                }
            }
            this.showWidgetHelpCenter = true;
        }
    }
    async closeThreadSidebar() {
        try {
            await this.SidebarContentService.cleanAndClose(false);
            this.activeThreadTicket = undefined;
        }
        catch (e) {
            console.error(e);
        }
    }
    async onChangeTab({ pos }) {
        if (pos !== this.currentTabIndex) {
            this.currentTabIndex = pos;
            this.startPaginationAndFilter();
            this.searchTerm.value = '';
            await this.refreshOnlyTab(this.isUseCacheEnable);
        }
    }
    loadQuery(param, items, key, updateItem) {
        if (this.$stateParams[param]) {
            const chosen = this[items].filter(item => {
                let params = [];
                if (Array.isArray(this.$stateParams[param])) {
                    params = this.$stateParams[param];
                }
                else {
                    params.push(this.$stateParams[param]);
                }
                if (params.includes(item[key])) {
                    return item[key];
                }
            });
            updateItem(chosen);
        }
    }
    loadTeamQuery() {
        if (this.$stateParams.team) {
            const teamParameter = this.$stateParams.team;
            const teamFilter = typeof teamParameter === 'string'
                ? [teamParameter]
                : [...teamParameter];
            teamFilter.forEach(team => {
                const chosenTeam = this.teamsToChoose.find(teamToChoose => teamToChoose.value === team);
                this.updateTeamChoices(chosenTeam);
            });
        }
    }
    setUrlQueryParameters(param, items, key) {
        this.$location.search(param, items.map((team) => team[key]));
    }
    updateTeamChoices(team) {
        this.teamsToChoose = this.teamsToChoose.filter(t => t.value !== team.value);
        this.teamsChosen = this.teamsChosen.concat({
            name: team.value,
            text: team.label,
        });
    }
    buildReportRequest() {
        return {
            teams: this.getTeamsChosenName(),
            agentIdentities: this.currentTabIndex !== 1 ? this.attendantsChosen.map((t) => t.value) : undefined,
            operators: this.currentTabIndex === 1 ? this.attendantsChosen.map((t) => t.value) : undefined,
            customerIdentities: this.customersToFilter.map((t) => t.value),
            agentStatus: this.currentTabIndex === 2 ? this.attendatsStatusChosen.map((t) => t.value) : undefined,
            refreshCache: this.refreshCache,
            take: this.itemsPerPage,
            skip: (this.page - 1) * this.itemsPerPage,
            searchTerm: this.searchTerm,
        };
    }
    formatAttendantsTimeString(attendants) {
        const undefinedToDash = true;
        attendants.forEach((element) => {
            element.averageAttendanceTime = this.formatTime({ value: element.averageAttendanceTime, undefinedToDash });
            element.averageCollapsedAttendanceTime = this.formatTime({ value: element.averageAttendanceTime, undefinedToDash, collapsed: true });
            element.averageResponseTime = this.formatTime({ value: element.averageResponseTime, undefinedToDash });
            element.averageCollapsedResponseTime = this.formatTime({ value: element.averageResponseTime, undefinedToDash, collapsed: true });
        });
        return attendants;
    }
    formatOpenTicketsTimeAndStatus(tickets) {
        return tickets.map((element) => {
            return {
                ...element,
                queueTime: formatTimeString(element.queueTime),
                collapsedQueueTime: formatTimeString(element.queueTime, true),
                firstResponseTime: formatTimeString(element.firstResponseTime),
                collapsedFirstResponseTime: formatTimeString(element.firstResponseTime, true),
                attendanceTime: formatTimeString(element.attendanceTime),
                collapsedAttendanceTime: formatTimeString(element.attendanceTime, true),
                status: TicketStatusEnum.Open,
            };
        });
    }
    formatWaitingTicketsTimeAndStatus(tickets) {
        return tickets.map((element) => {
            return {
                ...element,
                formatedSequentialId: `#${element.sequentialId}`,
                status: TicketStatusEnum.Waiting,
                queueTime: formatTimeString(element.queueTime),
                collapsedQueueTime: formatTimeString(element.queueTime, true),
            };
        });
    }
    sortAttendants(attendants) {
        return attendants.sort((a, b) => {
            if (a.status === b.status) {
                if (a.averageAttendanceTime !== undefined &&
                    b.averageAttendanceTime !== undefined) {
                    return b.averageAttendanceTime.localeCompare(a.averageAttendanceTime);
                }
                if (a.averageAttendanceTime === undefined) {
                    return 1;
                }
                if (b.averageAttendanceTime === undefined) {
                    return -1;
                }
                return b.averageAttendanceTime.localeCompare(a.averageAttendanceTime);
            }
            if (a.status === 'Online') {
                return -1;
            }
            if (b.status === 'Online') {
                return 1;
            }
            if (a.status === 'Pause') {
                return -1;
            }
            if (b.status === 'Pause') {
                return 1;
            }
            if (a.status === 'Invisible') {
                return -1;
            }
            return 1;
        });
    }
    formatTagsTimeString(tags) {
        const undefinedToDash = true;
        return tags.map((e) => ({
            ...e,
            averageAttendanceTime: this.formatTime({ value: e.averageAttendanceTime, undefinedToDash }),
            averageCollapsedAttendanceTime: this.formatTime({ value: e.averageAttendanceTime, undefinedToDash, collapsed: true }),
        }));
    }
    getAttendantName(attendant) {
        return getDecodedNodeName(attendant.agentName || attendant.identity);
    }
    getTicketAgentName(ticket) {
        return getDecodedNodeName(ticket.agentName || ticket.agentIdentity);
    }
    getTicketCustomerName(ticket) {
        return getDecodedNodeName(ticket.customerName || ticket.customerIdentity);
    }
    /**
     * Requests FullScreenService to enter fullscreen mode
     */
    requestDashboardSummaryFullScreen() {
        this.showWidgetHelpCenter = false;
        this.SegmentService.createApplicationTrack({ trackEvent: DashboardAttendanceConstants.MONITORING_FULLSCREEN_OPENED, payload: {} });
        this.dashboardSummaryElement = this.dashboardSummaryElement
            || document.querySelector('#desk-dashboard-summary');
        this.dashboardSummaryElement &&
            this.FullScreenService.requestFullScreen(this.dashboardSummaryElement);
    }
    /**
     * Requests FullScreenService to exit fullscreen mode
     */
    exitDashboardSummaryFullScreen() {
        this.FullScreenService.exitFullScreen();
        this.showWidgetHelpCenter = true;
    }
    applyTheme() {
        this.theme = this.FullScreenService.isOnFullScreen ? ThemeConstants.DARK : ThemeConstants.LIGHT;
    }
    /**
     * Get entire configuration object for Chart component
     *
     * @returns Object with properties for configuring Google Charts
     */
    getChartObject() {
        return {
            containerId: 'tickets-per-hour-chart',
            name: 'Tickets Test',
            category: 'ticketsPerHour',
            type: 'area',
            isLoading: true,
            options: this.getChartOptions(),
        };
    }
    /**
     * Get all options for styling Chart component
     *
     * @returns Object with properties for styling Google Charts
     */
    getChartOptions() {
        return {
            chartArea: {
                width: '94%',
            },
            width: '100%',
            height: '100%', //needed to ignore default 250px height
            areaOpacity: '1',
            backgroundColor: '#292929', //Surface/$color-surface-1
            colors: ['#0096FA'], //$color-brand
            fontSize: 14,
            enableInteractivity: 'false',
            lineWidth: 4,
            hAxis: {
                //eixo y
                baseline: 'none',
                gridlines: {
                    count: 0,
                },
                textStyle: {
                    color: '#94A3AB',
                },
            },
            vAxis: {
                // eixo x
                baseline: 'none',
                format: '0',
                gridlines: {
                    count: 5,
                    color: '#94A3AB',
                },
                minorGridlines: {
                    count: 0,
                },
                textStyle: {
                    color: '#94A3AB',
                },
            },
            pointSize: '0',
            legend: {
                position: 'none',
            },
        };
    }
    async getOwnerConfiguration(name) {
        return await this.ConfigurationsService.getSingle('postmaster@desk.msging.net', undefined, name, this.isConfigurationsApplicationsDomainUsageGetEnabled);
    }
    handleSearchCommandEvent(event) {
        if ((event.keyCode === 70 && event.ctrlKey) || (event.keyCode === 70 && event.metaKey)) {
            event.preventDefault();
            const element = document.querySelector('bds-input');
            element.setFocus();
        }
    }
    removePageEvents() {
        this.$window.removeEventListener('keydown', this.handleSearchCommandEvent);
    }
    async insertDirectTransferTranslationOnTeam(teamList) {
        const indexOfDirectTransfer = teamList.findIndex(team => team.name === AttendanceConstants.DIRECT_TRANSFER_TEAM);
        if (indexOfDirectTransfer >= 0) {
            teamList[indexOfDirectTransfer].name = await this.$translate('directTransfer');
        }
    }
    async insertDirectTransferTranslationOnTicketList(ticketList) {
        ticketList = ticketList.map(async (ticket) => {
            if (ticket.team === AttendanceConstants.DIRECT_TRANSFER_TEAM) {
                ticket.team = await this.$translate('directTransfer');
            }
            return ticket;
        });
    }
    async customCustomersSearch(value) {
        const filter = {
            or: this.isUsingStartsWithOnContactsSearch
                ? [
                    `startswith(name,'${value}')`,
                    `startswith(identity,'${value}')`,
                    `startswith(email,'${value}')`,
                    `startswith(phoneNumber,'${value}')`,
                ]
                : [
                    `substringof('${value}',name)`,
                    `substringof('${value}',identity)`,
                    `substringof('${value}',email)`,
                    `substringof('${value}',phoneNumber)`,
                ],
        };
        const filterQuery = buildQuery({ filter });
        let finalQuery = '&$filter=';
        if (filterQuery) {
            let filterQueryContent = filterQuery.split('?$filter=')[1];
            filterQueryContent += ' and ';
            const encodedQueryContent = encodeURIComponent(filterQueryContent);
            finalQuery += `${encodedQueryContent}`;
        }
        const excludeAttendantsQuery = encodeURIComponent("(source ne 'blip.ai' or source eq null)");
        finalQuery += excludeAttendantsQuery;
        try {
            const { items } = await this.UsersService.getUsers(finalQuery, 0, 100);
            return items.map(this.customerResponseToOptions);
        }
        catch (e) {
            console.error('Failed to get customers data', e);
            return [];
        }
    }
    getInfoIconSize() {
        return this.FullScreenService.isOnFullScreen ? 'small' : 'x-small';
    }
    formatTime({ value, zeroToDash = false, undefinedToDash = false, collapsed = false }) {
        value = formatTimeString(value, collapsed);
        return formatEmptyTimeV2(value);
    }
}
DashboardAttendanceController.$inject = ['application', 'PermissionsService', 'DeskConfigurationService', 'LoadingService', '$rootScope', '$location', '$timeout', '$stateParams', 'MESSAGINGHUBDOMAIN', 'ChatService', 'DashboardService', 'DashboardRealTimeMonitoringService', 'BucketService', 'SegmentService', 'AccountService2', 'UsersService', 'ConfigurationsService', 'TeamService', 'TagsQueueService', 'ModalService', 'ngToast', '$interval', '$translate', 'SidebarContentService', 'FullScreenService', '$document', '$state', '$scope', '$window', 'BlipToastService', 'AlertService', 'TenantService', 'PriorityLoadValues', 'MONITORING_SCREEN_REFRESH_PAGE_TIMEOUT'];
